import React from 'react';

import { selectStreamOptions } from '@vlabs/monokit/entities/sources/luna-streams/store/streams';
import { permissions } from '@vlabs/shared/config';
import { routes } from '@vlabs/shared/navigation/routes';
import { useSelector } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

import { StreamLinkBase } from './StreamLinkBase';

export const EventStreamLink = ({ streamId, ...props }) => {
  const streamOptions = useSelector(selectStreamOptions);
  const canView = useSelector((state) => viewerCan(state)([permissions.source.view]));
  const stream = streamOptions.find((s) => s.streamId === streamId);

  return (
    <StreamLinkBase
      canView={canView}
      route={routes.sources.lunaStreams.streams.view}
      stream={stream}
      streamId={streamId}
      {...props}
    />
  );
};
